import { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import "../../src/index.css";

const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function ComentariosModal({
  open,
  rol,
  tipoReporte,
  idOrder,
  handleClose,
  cantComentarios,
  setCantComentarios,
}) {
  const [comentariosFiltrados, setComentariosFiltrados] = useState([]);
  const [chatAdminSeleccionado, setChatAdminSeleccionado] = useState("STORE");
  const [nuevoComentario, setNuevoComentario] = useState("");
  const [comentarioRechazo, setComentarioRechazo] = useState("");
  const [creadoPor, setCreadoPor] = useState("");
  const [estatus, setEstatus] = useState("");

  /*
  console.log("rolDentroModal: ", rol);
  console.log("TIPO REPORTE MODAL", tipoReporte);
  console.log("COMENTARIOS FILTRADOS", comentariosFiltrados);
  console.log("CHAT ADMIN SELECCIONADO", chatAdminSeleccionado);
  console.log("CANT COMENTARIOS", cantComentarios);
  */

  const getInfoOrder = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getInfoOrderMongo`,
        {
          idOrder: idOrder,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      const campoTxt = tipoReporte ? `estatusTxt${tipoReporte}` : "";
      if (data.data[campoTxt]) {
        setEstatus(data.data[campoTxt]);
      }
      setCreadoPor(data.data.noemp);
      await filterComentario(data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const filterComentario = async (infoOrden) => {
    const mapTipoDocumento = {
      1: "RECEPCION",
      2: "24 HORAS",
      3: "48 HORAS",
    };
    const tipoDocumentoFiltro = mapTipoDocumento[tipoReporte];
    let comentariosVisibles = [];
    if (rol === "STORE") comentariosVisibles = infoOrden.comentariosStore;
    if (rol === "PROVIDER") comentariosVisibles = infoOrden.comentariosProvider;

    if (rol === "ADMIN" || rol === "SUPERVISOR") {
      comentariosVisibles =
        chatAdminSeleccionado === "STORE"
          ? infoOrden.comentariosStore
          : infoOrden.comentariosProvider;
    }
    const comentariosFiltrados2 = (comentariosVisibles || []).filter(
      (c) => c.tipoDocumento === tipoDocumentoFiltro,
    );
    setComentariosFiltrados(comentariosFiltrados2);
  };

  useEffect(() => {
    if (open) getInfoOrder();
  }, [open, chatAdminSeleccionado]);

  const handleAgregarComentario = async (rol) => {
    if (!nuevoComentario.trim()) return;
    try {
      const canal =
        rol === "PROVIDER"
          ? "PROVIDER"
          : rol === "STORE"
            ? "STORE"
            : rol === "ADMIN" || rol === "SUPERVISOR"
              ? chatAdminSeleccionado
              : "";
      Swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/addComentarioReporte`,
        {
          idOrder,
          texto: nuevoComentario,
          autor: rol,
          nombreAutor: creadoPor,
          tipoReporte,
          canal,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      setComentarioRechazo(nuevoComentario);
      Swal.close();
      getInfoOrder();
      setNuevoComentario("");
      setCantComentarios((prev) => prev + 1);
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo agregar el comentario",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const handleMarcarLeido = async (comentarioId) => {
    try {
      const canal =
        rol === "PROVIDER"
          ? "PROVIDER"
          : rol === "STORE"
            ? "STORE"
            : rol === "ADMIN" || rol === "SUPERVISOR"
              ? chatAdminSeleccionado
              : "";
      Swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });

      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/comentarios/leido`,
        { idOrder, comentarioId, rol: rol, canal },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      Swal.close();
      getInfoOrder();
    } catch (error) {
      Swal.close();
      console.error(error);
    }
  };

  const handleConfirmReporte = async () => {
    try {
      Swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/confirmReporte/${tipoReporte}`,
        { idOrder },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      Swal.close();
      setEstatus("ACEPTADO");
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: `La orden ha sido aceptada`,
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        didOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
      setCantComentarios(0);
      handleClose();
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cambiar el estatus",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        didOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
    }
  };

  const handleRechazarReporte = async () => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción rechazará la orden.",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#001F5B",
      confirmButtonText: "Sí, rechazar",
      cancelButtonText: "Cancelar",
      didOpen: (popup) => {
        popup.style.zIndex = 99999;
        popup.parentNode.style.zIndex = 99999;
      },
    });

    if (!result.isConfirmed) {
      return;
    }
    try {
      Swal.fire({
        title: "Cargando...",
        text: "Por favor espera",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
      await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/rechazarReporte`,
        { idOrder, tipoReporte, comentario: comentarioRechazo },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: process.env.REACT_APP_APIKEY,
          },
        },
      );
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: `La orden ha sido rechazada`,
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        didOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setComentarioRechazo("");
          setCantComentarios(0);
          handleClose();
        }
      });
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cambiar el estatus",
        confirmButtonColor: "#001F5B",
        confirmButtonText: "Aceptar",
        didOpen: (popup) => {
          popup.style.zIndex = 99999;
          popup.parentNode.style.zIndex = 99999;
        },
      });
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <svg
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            cursor: "pointer",
          }}
          onClick={handleClose}
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="red"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round">
          <path d="M10 10l4 4m0 -4l-4 4" />
          <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
        </svg>
        <Typography variant="h6">Comentarios del Reporte: {idOrder}</Typography>
        {(rol === "ADMIN" || rol === "SUPERVISOR") && (
          <div style={{ marginBottom: 10 }}>
            <Select
              size="small"
              value={chatAdminSeleccionado}
              onChange={(e) => setChatAdminSeleccionado(e.target.value)}>
              <MenuItem value="STORE">Tienda</MenuItem>
              <MenuItem value="PROVIDER">Proveedor</MenuItem>
            </Select>
          </div>
        )}

        {rol === "STORE" && (
          <div>
            <Typography variant="subtitle2" sx={{ mb: 0 }}>
              Estatus actual: {estatus}
            </Typography>
          </div>
        )}

        <List sx={{ maxHeight: 250, overflowY: "auto", mb: 2 }}>
          {comentariosFiltrados.length > 0 ? (
            comentariosFiltrados.map((c, index) => {
              /*const leido =
              c.autor === "STORE" ? c.leidoPorAdmin : c.leidoPorStore;*/

              const leido =
                c.autor === "STORE" || c.autor === "PROVIDER"
                  ? c.leidoPorAdmin
                  : (c.autor === "ADMIN" || c.autor === "SUPERVISOR") &&
                      chatAdminSeleccionado === "STORE"
                    ? c.leidoPorStore
                    : c.leidoPorProvider;
              /*const leido =
                c.autor === "STORE"
                  ? c.leidoPorStore
                  : c.autor === "PROVIDER"
                  ? c.leidoPorProvider
                  : c.leidoPorAdmin;*/

              //console.log("LEIDO", leido);

              const mostrarBoton =
                !leido &&
                (((rol === "ADMIN" || rol === "SUPERVISOR") &&
                  c.autor === "STORE") ||
                  (rol === "STORE" &&
                    (c.autor === "ADMIN" || c.autor === "SUPERVISOR")));
              //console.log("MOSTRAR BOTON", mostrarBoton);
              return (
                <ListItem
                  key={index}
                  sx={{
                    bgcolor: leido ? "#f0f0f0" : "#fff3cd",
                    mb: 1,
                    borderRadius: 1,
                  }}>
                  <ListItemText
                    primary={c.texto}
                    secondary={` Autor: ${c.autor} - Fecha: ${new Date(
                      c.fechaCreacion,
                    ).toLocaleString()} - Leído: ${leido ? "✔" : "❌"}`}
                  />
                  {mostrarBoton && (
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleMarcarLeido(c._id)} //descomentar
                    >
                      Marcar como leído
                    </Button>
                  )}
                </ListItem>
              );
            })
          ) : (
            <>
              <p>
                <Typography variant="subtitle2">Sin comentarios...</Typography>
              </p>
            </>
          )}
        </List>
        {((rol === "STORE" && comentariosFiltrados.length > 0) ||
          rol === "ADMIN" ||
          rol === "PROVIDER" ||
          rol === "SUPERVISOR") && (
          <>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Agregar Comentario
            </Typography>

            <TextField
              fullWidth
              placeholder="Escribe tu comentario aquí..."
              multiline
              rows={2}
              value={nuevoComentario}
              onChange={(e) => setNuevoComentario(e.target.value)}
              sx={{ mb: 2 }}
            />

            <div className="div-space">
              <Button
                variant="contained"
                onClick={() => handleAgregarComentario(rol)}
                disabled={!nuevoComentario.trim()}>
                Enviar Comentario
              </Button>

              {(rol === "ADMIN" || rol === "SUPERVISOR") &&
                estatus !== "RECHAZADO" && (
                  <Button
                    disabled={cantComentarios < 1}
                    variant="contained"
                    color="error"
                    onClick={() => handleRechazarReporte()}>
                    Rechazar
                  </Button>
                )}
              {(rol === "ADMIN" || rol === "SUPERVISOR") &&
                estatus !== "ACEPTADO" && (
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => handleConfirmReporte()}>
                    Confirmar
                  </Button>
                )}
            </div>
          </>
        )}
      </Box>
    </Modal>
  );
}
